import React, { useEffect } from 'react'
import HomeContainer from '../components/HomeContainer/HomeContainer'
import CustomTable from '../components/CustomTable/CustomTable'
import { fetchOrders } from '../hooks/Orders';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility'
import InvoiceContainer from '../components/InvoiceContainer/InvoiceContainer';

function HomeDashboard() {
          const {list:orders } = useSelector((state) => state.orders);
            const { currentLocal } = useSelector((state) => state.currentLocal);
          
          const dispatch=useDispatch();
            const navigate = useNavigate();

  useEffect(() => {
      dispatch(fetchOrders());

  }, [dispatch])

    const header = [
    { id: "id", numeric: false, disablePadding: true, label: currentLocal.home.ID },
        { id: "trackingNumber", numeric: true, disablePadding: false, label:currentLocal.home.order_no},
    { id: "date", numeric: true, disablePadding: false, label:  currentLocal.home.date},
    { id: "Totalamount", numeric: true, disablePadding: false, label: currentLocal.home.Totalamount},
      { id: "orderStatus", numeric: true, disablePadding: false, label: currentLocal.home.orderStatus},

    { id: "actions", numeric: true, disablePadding: false, label: currentLocal.home.actions },

  ];
const myData =orders?.map((item) => {
  console.log(item);
  
  return {
    id: item?.id,
    trackingNumber:item?.order_no||"------",
    date:item?.created_at?.slice(0,10)||"------",
    Totalamount:item?.total+currentLocal.home.egp||"------",
    orderStatus:item.status?.id==3?"proccing":item?.status?.id==4?"shipped":item?.status?.id==5?"Delivered":"Pending"||"------",
    actions: (
      <div className='d-flex align-items-center'>
        <div 
          className='d-flex align-items-center' 
          style={{ cursor: "pointer" }} 
          onClick={() => navigate(`/dashboard/order/${item?.id}`)}
        >
          <VisibilityIcon
            sx={{ 
              color: '#6C757D', 
              fontSize: '1rem', 
              marginLeft: '5px',
              marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
            }}
          />
          <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
            {currentLocal.home.Preview}
          </p>
        </div>
        <div>
                <InvoiceContainer
            trackingNumber={item?.order_no}
            createdAt={item && item?.created_at && item?.created_at.substring(0, 10)}
            total={item?.total}
            paymentMethod={item?.payment_method}
            address1={item?.address?.notes}
            subtotal={item?.subtotal}
            name={item?.client?.name}
            address2={
              item?.address
                ? `${item?.address.house_number || ""}, ${item?.address.block || ""}, ${item?.address.street || ""}`
                : ""
            }
            phone={item?.client?.phone}
            city={item?.address?.city?.name}
            region={item?.address?.region}
            street={item?.address?.street}
            block={item?.address?.block}
            house_number={item?.address?.house_number}
            items={item?.details}
            shippingAmount={item?.delivery_fee}

          />
        </div>
      </div>
    )
  };
});
  return (
    <div className='outlit_bg px-4'>
                      <HomeContainer
                      orders={orders}
                      />
      {orders?.length>0&&
            <div className='mx-4'>
              <CustomTable
                headCells={header}
                rows={myData} />
            </div>
      }
    </div>
  )
}

export default HomeDashboard
